// Copyright (C) Siemens AG 2026. All rights reserved. Confidential

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AppEnvironmentService {

  appEnvData: any = {baseApiUrl: ''};

  constructor(private http: HttpClient) { }

  loadAppEnvironmentData(): Observable<any> {
    return this.http.get("./assets/environments/appconfig.json");
  }

  setAppEnvironmentData(data: any) {
    this.appEnvData = data; 
  }
}
